import React, {useEffect, useRef} from 'react'
import PropTypes from 'prop-types'
import Font from '@cred/react-font'
import {Testable} from '@cred/react-testable'
import styles from './ScrollRequired.module.scss'

const handleScroll = (scrolled, setScrolled) => event => {
    const element = event.target

    /**
     * The full scroll height extends from the top of the scrollable content to
     * the bottom of the scrollable content. The user only has to scroll far enough
     * for the bottom of the content to be visible. Therefore, they do not need
     * to scroll the entire scroll height. We take the full scroll height and
     * subtract the element height to calculate how far a user has to scroll to
     * have viewed all of the content.
     */
    const distanceScrolled = element.scrollTop,
      fullScrollHeight = element.scrollHeight,
      fullElementHeight = element.offsetHeight,
      scrollableDistanceToBottom = fullScrollHeight - fullElementHeight

    if (distanceScrolled >= scrollableDistanceToBottom && !scrolled) {
      setScrolled(true)
    }
  },

  ScrollRequired = ({scrollRequiredProps: {className}, scrolled, setScrolled, children,  meta: {touched, error}}) => {
    const containerRef = useRef()
      
    const isError = touched && error
    useEffect(() => {
      const element = containerRef.current

      element.addEventListener('scroll', handleScroll(scrolled, setScrolled))
    }, [])
    return (
      <Testable testId="disclosures">
        <div ref={containerRef} className={[styles.container, className, isError && styles.scrollBoxError].join(' ')}>
          {children}
        </div>
        {isError && <Font type="bodySmall" color="error" className="mt-8 mb-16">{error}</Font>}
      </Testable>
    )
  }

ScrollRequired.propTypes = {

  /** Has the user scrolled to the bottom of the element? */
  scrolled: PropTypes.bool.isRequired,

  /** Function to set the value of 'scrolled' */
  setScrolled: PropTypes.func.isRequired,

  /** Inner content */
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]).isRequired,

  /**
   * Props specific to this component - created a special prop so that styles
   * could be passed down without interfering in other components
   */
  scrollRequiredProps: PropTypes.shape({className: PropTypes.string})
}

ScrollRequired.defaultProps = {
  scrollRequiredProps: {}
}

export {handleScroll}

export default ScrollRequired
